import { render, staticRenderFns } from "./EmdApplication.vue?vue&type=template&id=bd3d805e&"
import script from "./EmdApplication.vue?vue&type=script&lang=js&"
export * from "./EmdApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdApplication.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd3d805e')) {
      api.createRecord('bd3d805e', component.options)
    } else {
      api.reload('bd3d805e', component.options)
    }
    module.hot.accept("./EmdApplication.vue?vue&type=template&id=bd3d805e&", function () {
      api.rerender('bd3d805e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdApplication.vue"
export default component.exports